<template>
  <div class="culture-box">
    <banner-box />
    <p class="desc">
      <!--双華株式会社は2024年1月16日に設立され、<br/>-->
      <!--大連龍華木業有限公司と大連忠成木業有限公司の共同出資により設立された。-->
    </p>

    <div class="btns">
      <p
        v-for="(item, index) in btnData"
        class="btn"
        :class="{active: curSelect === index}"
        :key="index"
        @click="handleSelect(index)"
      >
        <span class="name">{{item.name}}</span>
        <span class="img">↓</span>
      </p>
    </div>

    <div class="content">
      <div class="selects">
        <p class="title">Company</p>
        <div class="items">
          <p
            v-for="(item, index) in btnData"
            class="item"
            :class="{active: curSelect === index}"
            :key="index"
            @click="handleSelect(index)"
          >{{item.name}}</p>
        </div>
      </div>
      <p class="line"></p>
      <div class="rows">
        <div
          v-for="(item, index) in btnData[curSelect].data"
          class="row"
          :key="index"
        >
          <p class="title">{{item.title}}</p>
          <p class="url-box">
            <img class="img" :src="item.url" alt="img">
          </p>
          <p class="name">{{item.name}}</p>
          <textarea class="content-box" v-model="item.content" readonly />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { qyyg } from '../../api/home'

export default {
  name: 'index',
  data () {
    return {
      curSelect: 0,
      btnData: [
        // {
        //   name: '双華株式会社',
        //   data: [
        //     {
        //       title: '双華株式会社',
        //       url: '',
        //       name: '双華株式会社',
        //       content: '会社成立日：2024年1月16日\n' +
        //         '住所：福岡県北九州市小倉北区紺屋町１３番１号\n' +
        //         '取扱商品：家具、構造材、合板、建材、ＬＶＬ間柱、集成材、木製DIY商品、吸音パネ儿、原木'
        //     }
        //   ]
        // },
        // {
        //   name: '建材展2024',
        //   data: [
        //     {
        //       title: '建材展2024',
        //       url: '',
        //       name: '2024年3月12（火）-15日（金）',
        //       content: '東京ビックサイトで第30回建築.建材展2024に出展しました。'
        //     }
        //   ]
        // }
      ]
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getCultureData()
    },
    async getCultureData () {
      const { data } = await qyyg()
      console.log('getCultureData==>', data)
      this.btnData = data.map(v => {
        return {
          name: v.title,
          data: [
            {
              title: v.title,
              url: v.coverPath,
              name: v.pic_title,
              content: v.description
            }
          ]
        }
      })
    },
    handleSelect (index) {
      this.curSelect = index
    }
  }
}
</script>

<style lang="less" scoped>
.culture-box{
  display: flex;
  flex-direction: column;

  .desc{
    font-family: 04KanjyukuGothic;
    font-weight: 400;
    font-size: 20px;
    color: #666666;
    line-height: 34px;
    margin-top: 58px;
    margin-left: 279px;
  }

  .btns{
    margin-top: 53px;
    margin-left: 259px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .btn{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding: 0px 48px;
      height: 81px;
      background: #E6F0F7;
      border-radius: 40px;
      text-align: center;
      margin-right: 46px;
      cursor: pointer;
      transition: all .2s linear;

      &.active{
        background: #374475;

        .name{
          color: #f6f6f6;
        }
      }

      .name{

        font-weight: 400;
        font-size: 30px;
        color: #374475;
        line-height: 81px;
      }

      .img{
        flex-shrink: 0;
        width: 27px;
        height: 27px;
        background: #E6F0F7;
        border-radius: 50%;
        border: 2px solid #374475;
        display: inline-block;
        line-height: 27px;
        font-size: 12px;
        font-weight: bold;
        margin-left: 18px;
      }
    }
  }

  .content{
    margin-top: 68px;
    margin-left: 259px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;

    position: relative;

    .selects{
      display: flex;
      flex-direction: column;
      padding-bottom: 122px;
      width: 371px;

      .title{
        font-weight: 400;
        font-size: 24px;
        color: #374475;
        margin-left: 31px;
        margin-top: 28px;
        margin-bottom: 24px;
      }

      .items {
        margin-top: 32px;

        .item {
          height: 23px;
          font-family: 04 KanjyukuGothic;
          font-weight: 400;
          font-size: 24px;
          color: #cccccc;

          padding-left: 31px;
          margin-bottom: 27px;

          position: relative;
          cursor: pointer;

          &.active{
            color: #374475;

            &:before{
              background: #374475;
            }
          }

          &:before{
            content: '';
            position: absolute;
            top: 14px;
            left: 4px;
            width: 6px;
            height: 6px;
            background: #CCCCCC;
            border-radius: 50%;
          }
        }
      }
    }

    .line{
      position: absolute;
      top: 0px;
      left: 296px;
      width: 1px;
      height: 100%;
      background-color: #cccccc;

      &:before{
        content: '';
        width: 12px;
        height: 12px;
        background: #374475;
        border-radius: 6px;
        position: absolute;
        top: -6px;
        left: -6px;
      }
    }

    .rows{
      display: flex;
      flex-direction: column;

      .title{
        width: 210px;
        height: 98px;
        background: #374475;
        border-radius: 10px 10px 10px 0px;

        font-family: 04KanjyukuGothic;
        font-weight: 400;
        font-size: 24px;
        color: #FFFFFF;
        line-height: 98px;
        text-align: center;
        position: relative;
        z-index: 10;
      }

      .url-box{
        width: 1029px;
        height: 571px;
        /*background: wheat;*/
        border-radius: 10px;
        margin-top: -41px;

        .img{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .name{
        height: 34px;
        font-family: 04KanjyukuGothic;
        font-weight: 400;
        font-size: 36px;
        color: #374475;
        line-height: 34px;
        margin-top: 57px;
      }

      .content-box{
        width: 872px;
        height: 200px;
        font-family: 04KanjyukuGothic;
        font-weight: 400;
        font-size: 20px;
        color: #333333;
        line-height: 30px;
        border: none;
        outline: none;
        user-select: none;
        margin-top: 28px;
      }
    }
  }
}
</style>
